import React, { useEffect, useState } from "react";
import { Layout, Typography, Divider, Table, Button, Space, DatePicker, Menu, Dropdown, Tabs, Col, Statistic, Card } from "antd";
import { apiCall } from "../../utils/Api";
import Html from "../../utils/Html";
import { Link } from "react-router-dom";
import { CloseOutlined } from '@ant-design/icons';
import moment from "moment";
import TitlesTable from "./TitlesTable";
import OrdersTable from "./OrdersTable";
import CustomerPOTable from "./CustomerPOTable";
import { pluralize, addCommas } from "../../utils/Utils";
import Paginate from "../Paginate";

export default function CustomersTable(props) {

    const { filters, border = true } = props;
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState([]);
    const [table, setTable] = useState("table");
    const [results, setResults] = useState({ rows: [], row_count: 0 });
    const [paginate, setPaginate] = useState({ current: 1, pagesize: 20, offset: 0 });

    const expandCell = (_data, _table) => {
        if (!expanded.includes(_data.key)) {
            setTable(_table);
            setExpanded([_data.key]);
        } else {
            if (_table === table) {
                setExpanded([]);
            } else {
                setTable(_table);
            }
        }
    }

    const addKeys = (_arr) => {
        return (_arr.map((item) => {
            item["key"] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
            return item;
        }))
    }

    // Fetch Data if not set
    const getSummary = () => {
        setLoading(true)
        let _filters = {...filters}
        _filters.limit = paginate.pagesize;
        _filters.offset = paginate.offset;

        apiCall("orders/getCustomer", _filters, (_status, _results) => {
            if (_status) {
                addKeys(_results.rows);
                setResults(_results)
                setLoading(false)
            }
        })
    }
    useEffect(getSummary, [filters, paginate]);



    const getTable = (_record) => {

        switch (table) {
            case "titles":
                let title_fltrs = { ...filters }
                title_fltrs["customer_id"] = _record.customer_id;
                title_fltrs["nesting"] = "customer_id";
                return <TitlesTable pagination={false} border={false} data={results} filters={title_fltrs} />

            case "orders":
                let order_fltrs = { ...filters }
                order_fltrs["customer_id"] = _record.customer_id;
                order_fltrs["nesting"] = "customer_id";
                return <OrdersTable pagination={false} border={false} data={results} filters={order_fltrs} />

            case "purchase_orders":
                let purchase_fltrs = { ...filters }
                purchase_fltrs["customer_id"] = _record.customer_id;
                purchase_fltrs["nesting"] = "customer_id";
                return <CustomerPOTable pagination={false} border={false} filters={purchase_fltrs} />
        }

    }


    const drawChildTable = (_record, _another) => {
        return (
            <div className="hideHover" style={{ "margin": "-7px" }}>
                <div style={{ "padding": "0 20px" }}>
                    <div style={{ "marginTop": "0px", "borderTop": "none", "marginBottom": "0px" }} className="closebar">
                        <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px" }} /></small>} />
                        <br clear="both" />
                    </div>
                </div>
                <div style={{ "padding": "0px 0px" }}>
                    {getTable(_record)}
                </div>
            </div>
        )
    }

    const customer_columns = [
        { key : "blank", width : "10px"},
        { title: <small>Name</small>, dataIndex: 'name', key: 'name' },
        {
            title: <small>Ordered</small>, dataIndex: 'date_ordered', key: 'date_ordered', render: (e) => {
                return moment(e * 1000).tz('America/Los_Angeles').format("MMM Do YYYY - h:mma");
            }
        },
        { title: <small>Quantity</small>, dataIndex: 'quantity', key: 'quantity' },
        {
            title: <small>Price</small>, dataIndex: 'price', key: 'price', render: (e) => {
                return (e) ? "$" + addCommas(e) : "";
            }
        },
        {
            title: <small>Titles</small>, dataIndex: 'number_of_titles', key: 'number_of_titles', render: (e, f) => {
                return <a onClick={() => expandCell(f, "titles")} type="link">
                    {e} {pluralize(e, "Title", "s")}
                </a>
            }
        },
        {
            title: <small>Orders</small>, dataIndex: 'number_of_orders', key: 'number_of_orders', render: (e, f) => {
                return <a onClick={() => expandCell(f, "orders")} type="link">{e}</a>
            }
        },

    ]


    // strip purchase orders if already filtered..
    if (!filters.hasOwnProperty("nesting")) {
        customer_columns.push(
            {
                title: <small>Purchase Orders</small>, dataIndex: 'number_of_purchase_orders', key: 'number_of_purchase_orders', render: (e, f) => {
                    return <Button size="small" onClick={() => expandCell(f, "purchase_orders")} type="link">{e}</Button>
                }
            }
        )
    }

    return (
        <>
            <Paginate paginate={paginate} setPaginate={setPaginate} count={results.row_count} />
            <Table expandable expandIcon={<></>} size="small" pagination={true}
                columns={customer_columns}
                loading={loading}
                className={"tableNoBorder"}
                dataSource={results.rows}
                expandIconColumnIndex={-1}
                expandedRowKeys={expanded}
                onExpand={(e) => { return false; }}
                expandedRowRender={((record) => drawChildTable(record))}
            />
            <Paginate paginate={paginate} setPaginate={setPaginate} count={results.row_count} />
        </>);


}